import {
    App, Steps, Row, Col, Button, Layout, List, Tag, Typography, Modal,
} from 'antd';
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import {showApiError} from "../../utility/error/error-handler";
import {formatAddress, getRandomInt, getSessionData} from "../../utility/global-util";
import PanelFrame from '../../components/panels/PanelFrame';
import { getCurrentEvent } from "../../api/vehicle";
import {
    CalendarOutlined, BorderlessTableOutlined, EnvironmentOutlined, ToolOutlined,
    CarOutlined, 
} from "@ant-design/icons";
import ExpandableText from '../../components/data/ExpandableText';
import { useScreenSizeBelow } from "../../utility/hooks/useScreenSize";
import { iconLocations } from "../../components/image/IconLocations";
import DataCard from '../../components/data/DataCard';
import { AdvancedMarker, APIProvider, Map } from '@vis.gl/react-google-maps';
import { setKey, fromAddress  } from "react-geocode";

const { Text} = Typography;

const ProgressBar = ({eventType, eventData}) => {
    const { t } = useTranslation();
    let items = [];
    let current = 0;

    if (eventType && eventType.category === 'MAINTENANCE')
    {
        items = [{
            title: t('value.booking_requested')
        },
        {
            title: t('value.booking_confirmed')
        },
        {
            title: t('value.in_progress')
        },
        {
            title: t('value.work_completed')
        }];
        if(eventType.type === 'CONFIRMED')
        {
            current = 1;
        }
        else if(eventType.type === 'JOB')
        {
            current = 2;
        }
        else if(eventType.type === 'JOB-FINISHED')
        {
            current = 3;
        }
    }
    if (eventType && eventType.category === 'BREAKDOWN')
    {
        if (eventType.type === 'ASSISTANCE')
        {
            items = [{
                title: t('value.assistance_required')
            },
            {
                title: t('value.assistance_organised')
            },
            {
                title: t('value.in_progress')
            },
            {
                title: t('value.complete')
            }];
            
            if (eventData.status === 'ROADSIDE_ASSISTANCE_REQUIRED')
            {
                current = 0;
            }
            else if (eventData.status === 'ROADSIDE_ASSISTANCE_ORGANISED')
            {
                current = 1;
            }
            else if (eventData.status === 'ASSISTANCE_IN_PROGRESS' || eventData.status === 'RECOVERY_REQUIRED' )
            {
                current = 2;
            }
        }
        if (eventType.type === 'RECOVERY')
        {
            items = [
            {
                title: t('value.recovery_organised')
            },
            {
                title: t('value.recovery_started')
            },
            {
                title: t('value.complete')
            }];

            
            if (eventData.status === 'RECOVERY_ORGANISED')
            {
                current = 0;
            }
            else
            {
                current = 1;
            }
        }
    }
        
    return <Row style={{width:"100%"}}>
             <Steps current={current} items={items} size={"small"} direction={!useScreenSizeBelow(850) ? "default" : "vertical"}/>
           </Row>
}

const DisplayMap = ({address, onClick}) => {
    //console.log(onClick);
    const [location, setLocation] = useState(null);
    setKey(getSessionData('REACT_APP_MAPS_KEY'));
    useEffect(() => {
      fromAddress(address)
        .then(({ results }) => {
          setLocation(results[0].geometry.location);
          console.log(results[0].geometry.location);
         })
        .catch(console.error);
      },[address]);
    return (
    location
    ?
    <APIProvider apiKey={getSessionData('REACT_APP_MAPS_KEY')}>                   
    <Map
      clickableIcons={false}
      id='current-event-location-map'
      // reuseMaps
      mapId={"current-event-location"}
      mapTypeControlOptions={{mapTypeIds: ["ROADMAP"]}}
      defaultZoom={15}
      onClick={(ev) => {onClick()}}
      center={location}
    >
      <AdvancedMarker position={location} />
   </Map>
   </APIProvider>
   :
   <></>)
  
}

function getTagColour(status)
{
    if(status === "AUTHORISED")
    {
        return "lime"
    }
    if(status === "DEFERRED")
    {
        return "purple"
    }
    if(status === "CUSTOMER_REJECTED")
    {
        return "red"
    }
    if(status === "CUSTOMER_APPROVAL_REQUESTED")
    {
        return "volcano"
    }
    if(status === "COMPLETE")
    {
        return "green"
    }
    if(status === "NOT_DONE")
    {
        return "black"
    }
    if(status === "AUTHORITY_REQUESTED")
    {
        return "gold"
    }
    if(status === "CANCELLED")
    {
        return "darkgrey"
    }
    if(status === "CREATED")
    {
        return "geekblue"
    }
    if(status === "CUSTOMER_APPROVAL_REQUIRED")
    {
        return "orange"
    }
    if(status === "CUSTOMER_APPROVED")
    {
        return "chartreuse"
    }
    if(status === "DECLINED")
    {
        return "orangered"
    }
    if(status === "REVIEWED_AUTHORISED")
    {
        return "seagreen"
    }
    if(status === "REVIEWED_REVISE")
    {
        return "aquamarine"
    }
    if(status === "REVIEWED_DECLINED")
    {
        return "firebrick"
    }
    if(status === "REVIEWED_DEFERRED")
    {
        return "magenta"
    }
    if(status === "RESCHEDULED")
    {
        return "cyan"
    }
    if(status === "SUPPLIER_REQUESTED_APPROVAL")
    {
        return "goldenrod"
    }
}

const CurrentMaintenance = ({type, data}) => {
    const isSmallScreen = useScreenSizeBelow(769);
    const { t } = useTranslation();
    const openInNewWindow = () => {
        window.open("https://www.google.com/maps/search/?api=1&query=" + data.supplierName + "+" + formatAddress(data.supplierAddress, "+"), "_blank", "noreferrer");
    }
    
    if(type === 'PLANNED' || type === 'CONFIRMED')
    {
        return <> 
          <Row style={{width:"100%"}}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <BorderlessTableOutlined /><Text style={{ marginLeft: '5px' }}>{data.reference}</Text>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <CalendarOutlined /><Text style={{ marginLeft: '5px' }}>{data.bookingDate}</Text>
            </Col>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                <EnvironmentOutlined /><Text style={{ marginLeft: '5px' }}>{data.supplierName?data.supplierName:t("value.tbc")}</Text>
            </Col>
        </Row>
        <Row>
           <Col xs={24} sm={24} md={24} lg={data.supplierAddress ? 15 : 24} xl={data.supplierAddress ? 15 : 24}>
               <table cellSpacing={0} cellPadding={0}>
                   <tbody>
                    <tr>
                        <td style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}><ToolOutlined style={{ marginRight: '5px', marginTop: '5px' }} /></td>
                        <td><Text>{data.workRequired}</Text></td>
                    </tr>
                   </tbody>
               </table>
           </Col>
           <Col xs={24} sm={24} md={24} lg={data.supplierAddress ? 1 : 24} xl={data.supplierAddress ? 1 : 24}><></></Col>
           <Col xs={24} sm={24} md={24} lg={data.supplierAddress ? 8 : 24} xl={data.supplierAddress ? 8 : 24}>
           {
                data.supplierAddress
                ?
                <>
                   <Row><ExpandableText text={formatAddress(data.supplierAddress)}/></Row>
                   <Row><a href={"https://www.google.com/maps/search/?api=1&query=" + data.supplierName + "+" + formatAddress(data.supplierAddress, "+")} target="_blank" rel="noreferrer">{t('action.show_on_map')}</a></Row>
                   {
                       !isSmallScreen && getSessionData('REACT_APP_MAPS_KEY')
                       ?
                       <Row style={{'width' : '100%', 'height' : '200px'}}><DisplayMap address={formatAddress(data.supplierAddress)} onClick={openInNewWindow}/></Row>
                       :
                       <></>
                   }
                </>
                :
                <></>
           }
           </Col>           
        </Row>
        </>
    }
    else if(type === 'JOB' || type === 'JOB-FINISHED')
    {
        return <div>
        <Row style={{width:"100%"}}>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <BorderlessTableOutlined /><Text style={{ marginLeft: '5px' }}>{data.reference}</Text>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <img src={iconLocations.CHECKERED_FLAG_ICON} style={{height:"1em"}} alt="" /><Text style={{ marginLeft: '5px' }}>{data.expectedCompletionDate}</Text>
        </Col>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
            <Row>
                <EnvironmentOutlined /><Text style={{ marginLeft: '5px' }}>{data.supplierName}</Text>
                {data.supplierReference ? <span><Text style={{ margin: '0 7px' }}>-</Text><BorderlessTableOutlined /><Text style={{ marginLeft: '5px' }}>{data.supplierReference}</Text></span> : <></>}
            </Row>
            {
            data.supplierAddress && isSmallScreen
            ?
            <>
               <Row><ExpandableText text={formatAddress(data.supplierAddress)}/></Row>
               <Row><a href={"https://www.google.com/maps/search/?api=1&query=" + data.supplierName + "+" + formatAddress(data.supplierAddress, "+")} target="_blank" rel="noreferrer">{t('action.show_on_map')}</a></Row>
            </>
            :
            <></>
        }
        </Col>
        </Row>
        <Row>
        <Col xs={24} sm={24} md={16} lg={16} xl={16}>
        {
            data.jobItems && data.jobItems.length > 0
            ?
            <List
              dataSource={data.jobItems}
              renderItem={(item) => (
                <List.Item key={getRandomInt(1, 1000)}>
                    <Text><Tag key={data.jobItems.indexOf(item)} color={getTagColour(item.status.key)}>{item.status.description}</Tag>{item.description}</Text>
                </List.Item>
              )}
            />
            :
            <></>
        }
        </Col>
        <Col xs={24} sm={24} md={16} lg={8} xl={8}>
        {
            data.supplierAddress && !isSmallScreen
            ?
            <>
               <Row><ExpandableText text={formatAddress(data.supplierAddress)}/></Row>
               {
               getSessionData('REACT_APP_MAPS_KEY')
               ?
               <Row style={{'width' : '100%', 'height' : '200px'}}><DisplayMap address={formatAddress(data.supplierAddress)} onClick={openInNewWindow}/></Row>
               :
               <Row><a href={"https://www.google.com/maps/search/?api=1&query=" + data.supplierName + "+" + formatAddress(data.supplierAddress, "+")} target="_blank" rel="noreferrer">{t('action.show_on_map')}</a></Row>
               }
            </>
            :
            <></>
        }
        </Col>
        </Row>
        </div>
    }
    else
    {
        return <></>
    }
}

const AdditionalDataModal = ({type, data, modalDisplayed, setModalDisplayed}) => {
    const { t } = useTranslation();
    function getTitle()
    {
        if (data && data.otherJobs?.length > 0 && data.otherBookings?.length > 0)
        {
            return t('title.other_jobs_and_bookings')
        }
        else if (data && data.otherJobs?.length > 0)
        {
            return t('title.other_jobs')
        }
        else if (data && data.otherBookings?.length > 0)
        {
            return t('title.other_bookings')
        }         
    }

    const OtherJobsAndBookings = () => {
        const getBookingStatus = (status) => {
            // use job status similar to the way the type is set on the main job (progress bar)
            if(status === 'CREATED') {
                return t('value.booking_requested');
            }
            else if(status === 'CONFIRMED') {
                return t('value.booking_confirmed');
            }
        }
        const getJobStatus = (status) => {
            // use job status similar to the way the type is set on the main job (progress bar) - jobs where PO CREATED or later and the vehicle has been returned excluded
            if (status === 'PO_CREATED' || status === 'INVOICE_RECEIVED' || status === 'RECHARGE_REVIEW_REQUIRED' || status === 'COMPLETE') {  //complete excluded (not open) but keeping as part of PO CREATED or later
                return t('value.work_completed');
            } else {
                return t('value.in_progress');
            }
        }

        // Variable Styling
        let titleColour = 'var(--dp-panel-text-colour)';

        return (
          <div>
          {data && data.otherJobs?.length > 0
          ?
          <div>
                
           <Text className='modal-popup-subheader' style={{ color: titleColour }}> {t('title.jobs')} </Text>

          <List>
            {data.otherJobs.map(job => (
                
              <List.Item key={job.reference}>
                <DataCard
                  header={job.reference}
                >
                <div style={{"width" : "100%"}}>
                  <Row justify="space-between">
                      <span><img src={iconLocations.CHECKERED_FLAG_ICON} style={{height:"1em"}} alt="" /><Text style={{ marginLeft: '5px' }}>{job.expectedCompletionDate}</Text></span>
                      <Text>{getJobStatus(job.status)}</Text>
                  </Row>
                  <Row>
                    <EnvironmentOutlined /><Text style={{ marginLeft: '5px' }}>{job.supplierName}</Text>
                    {job.supplierReference ? <span><Text style={{ margin: '0 7px' }}>-</Text><BorderlessTableOutlined /><Text style={{ marginLeft: '5px' }}>{job.supplierReference}</Text></span> : <></>}
                  </Row>
                  <Row>{
                    job.jobItems  && job.jobItems.length > 0
                    ?
                    <List
                       dataSource={job.jobItems}
                       renderItem={(item) => (
                          <List.Item key={getRandomInt(1, 1000)} style={{"width" : "100%"}}>
                              <Text><Tag color={getTagColour(item.status.key)}>{item.status.description}</Tag>{item.description}</Text>
                          </List.Item>
                       )}
                    />
                    :
                    <></>
                    }
                  </Row>
                </div>
              </DataCard>                
          </List.Item>
          ))}
          </List>
          </div>
          :
          <></>
          }
          {
          data && data.otherBookings?.length > 0
          ?
          <div>
            <Text className='modal-popup-subheader' style={{ color: titleColour, display: 'inline-block', marginTop: '10px' }}> {t('title.bookings')} </Text>
            <List>
            {data.otherBookings.map(booking => (
              <List.Item key={booking.reference}>
                <DataCard
                  header={booking.bookingDate + (booking.supplierName? " @ " + booking.supplierName : "")}
                >
                {
                <div style={{"width" : "100%"}}>
                    <Row justify="space-between">
                        <Row><BorderlessTableOutlined /><Text style={{ marginLeft: '5px' }}>{booking.reference}</Text></Row>
                        <Text>{getBookingStatus(booking.status)}</Text>
                    </Row>
                    <Row>
                        <ExpandableText text={booking.workRequired}/>
                    </Row>
                </div>
                }
              </DataCard>                
              </List.Item>
              ))}
            </List>
          </div>
          :
          <></>
          }
      </div>);
    }

    return <Modal className="std-portal-popup"
              open={modalDisplayed}
              title={getTitle()}
              closable={true}
              maskClosable={true}
              keyboard={true}
              footer={null}
              onCancel={() => {setModalDisplayed(false)}}>
            {
                type && type.category === 'MAINTENANCE'
                ?
                <OtherJobsAndBookings/>
                :
                <></>
            }
            </Modal>;
}

const BreakdownProblemDescription = ({problem}) => {
    return (
             <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <table cellSpacing={0} cellPadding={0}>
                    <tbody>
                        <tr>
                            <td style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                <ToolOutlined style={{ marginRight: '5px', marginTop: '5px' }} />
                            </td>
                            <td>
                                <ExpandableText text={problem}/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>        
    )
}

const BreakdownLocation = ({location}) => {
    return (
             <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <table cellSpacing={0} cellPadding={0}>
                    <tbody>
                        <tr>
                            <td style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                <CarOutlined style={{ marginRight: '5px', marginTop: '5px' }} />
                            </td>
                            <td>
                                <ExpandableText text={location}/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>  
    )
}

const RecoverToDestination = ({address, recoverToSupplier}) => {
    return (
             <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <table cellSpacing={0} cellPadding={0}>
                    <tbody>
                        <tr>
                            <td style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                                <EnvironmentOutlined style={{ marginRight: '5px', marginTop: '5px' }} />
                            </td>
                            <td>
                                <ExpandableText text={recoverToSupplier ? formatAddress(address) : address}/>
                            </td>
                        </tr>
                    </tbody>
                </table>
             </Col>  
    )
}

const CurrentBreakdown = ({type, data, setRefreshDynamicPanel}) => {
    const isSmallScreen = useScreenSizeBelow(769);
    const { t } = useTranslation();
    const openInNewWindow = () => {
        window.open("https://www.google.com/maps/search/?api=1&query=" + data.recoverToSupplier + "+" + formatAddress(data.recoveryToAddress, "+"), "_blank", "noreferrer");
    }
    
    let showETA = !data.hasAssistanceOrRecoveryArrived && data.agentRespondingETA;
    let recoverToSupplier = data.recoveryDestination === 'SUPPLIER';
    let recoverToAlternate = data.recoveryDestination === 'ALTERNATIVE';

    return (
                 <div>
                    <Row style={ {width:"100%"} } justify="space-between"> 
                        <Col style={{marginBottom: '3px'}} xs={24} sm={24} md={12} lg={8} xl={8}>
                          <BorderlessTableOutlined /><Text style={{ marginLeft: '5px'}}>{data.reference}</Text>
                        </Col>
                        {
                            showETA
                            ? 
                            <Col style={{marginBottom: '3px'}}xs={24} sm={24} md={12} lg={8} xl={8}>
                                <img src={iconLocations.CHECKERED_FLAG_ICON} style={{height:"1em"}} alt="" /><Text style={{ marginLeft: '5px' }}>{data.agentRespondingETA}</Text>
                            </Col>
                            :
                            <></>
                        }
                        <Col style={{marginBottom: '3px'}}xs={24} sm={24} md={12} lg={8} xl={8}>
                        {
                        data.agentResponding 
                        ?
                         <span style={ {width:"100%"} }>
                            <ToolOutlined /><Text style={{ marginLeft: '5px' }}>{data.agentResponding}</Text>
                         </span>
                        :                        
                        <></>
                        }
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={24} sm={24} md={16} lg={16} xl={16}>
                          <Row style={ {marginBottom: '5px'} }>
                           <BreakdownProblemDescription problem={data.problemDescription}> </BreakdownProblemDescription>
                           </Row>
                           <Row style={ {marginBottom: '5px'} }>
                            <BreakdownLocation location={data.locationDescription}> </BreakdownLocation>
                           </Row>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        {
                            data.recoveryToDestination && recoverToSupplier
                            ?
                              isSmallScreen
                              ?
                              <>
                                <Row>
                                  <RecoverToDestination address={data.recoveryToAddress} recoverToSupplier={true}></RecoverToDestination>
                                </Row>
                                <Row>
                                    <a href={"https://www.google.com/maps/search/?api=1&query=" + data.recoveryToDestination + "+" + formatAddress(data.recoveryToAddress, "+")} target="_blank" rel="noreferrer">{t('action.show_on_map')}</a>
                                </Row>
                              </>
                              :
                              <>
                                <RecoverToDestination address={data.recoveryToAddress} recoverToSupplier={true}></RecoverToDestination>
                                {
                                    getSessionData('REACT_APP_MAPS_KEY')
                                    ?
                                    <Row style={{'width' : '100%', 'height' : '200px'}}>
                                        <DisplayMap address={formatAddress(data.recoveryToAddress)} onClick={openInNewWindow}/>
                                    </Row>
                                    :
                                    <></>
                                }                            
                              </>
                            :
                               data.recoveryToDestination && recoverToAlternate
                               ?
                               <>
                                <RecoverToDestination address={data.recoveryToDestination} recoverToSupplier={false}></RecoverToDestination>
                               </>
                               :
                               <></>
                        }
                        </Col>           
                    </Row>
                </div>            
               )
}

const CurrentEventPanel = ({vehicle, refreshPage, setRefreshPage, setPageLoading}) => {
    const { t } = useTranslation();
    const { notification } = App.useApp();
    const [eventData, setEventData] = useState(null);
    const [ displayModal, setDisplayModal] = useState(false);
    const [ refreshDynamicPanel, setRefreshDynamicPanel] = useState(false);
    const [ refreshBreakdown, setRefreshBreakdown] = useState(false);
    const [ eventProgress, setEventProgress ] = useState(100);

    useEffect(() => {
        if (vehicle) {
            // Get current event - no offline handling here as panel should not be displayed offline
            getCurrentEvent(vehicle.vehicleId, setEventProgress)
                .then(res => {
                    setEventData(res);
                    if (res && res.type && res.type.category === 'BREAKDOWN')
                    {
                        setRefreshBreakdown(true);
                    }
                    else
                    {
                        setRefreshBreakdown(false);
                    }
                    setTimeout(() => setPageLoading(false), 1000); //slight delay for contract to be changed first
                },)
                .catch(err => {
                    setTimeout(() => setPageLoading(false), 1000);
                    showApiError('Current Event', err, notification);
                });
        }
        setRefreshPage(false);
        setRefreshDynamicPanel(false);
    }, [t, notification, vehicle, refreshPage, setRefreshPage, refreshDynamicPanel, setRefreshDynamicPanel, setPageLoading]);

    function getTitle(){
        if (eventData && eventData.type) {
            if (eventData.type.category === 'MAINTENANCE') {
                if (eventData.type.type === 'JOB' || eventData.type.type === 'JOB-FINISHED') {
                    return t('title.current_job');
                }
                return t('title.next_booking');
            }
            if (eventData.type.category === 'BREAKDOWN') {
                return t('title.current_breakdown');
            }
        }
        return '';
    }

    function getButtons(){
        let result = [];
        if (eventData && eventData.type && eventData.data && eventData.type.category === 'MAINTENANCE')
        {
            if (eventData.data.otherJobs?.length > 0 && eventData.data.otherBookings?.length > 0)
            {
                result.push(<Button key={getRandomInt(1, 1000)} type="primary" onClick={() => {setDisplayModal(true)}}>{t('title.other_jobs_and_bookings')}</Button>);
            }
            else if (eventData.data.otherJobs?.length > 0)
            {
                result.push(<Button key={getRandomInt(1, 1000)} type="primary" onClick={() => {setDisplayModal(true)}}>{t('title.other_jobs')}</Button>);
            }
            else if (eventData.data.otherBookings?.length > 0)
            {
                result.push(<Button key={getRandomInt(1, 1000)} type="primary" onClick={() => {setDisplayModal(true)}}>{t('title.other_bookings')}</Button>);
            }
        }
        return result;
    }

    if (eventData && eventData.type && eventData.data) {
      return (
        <PanelFrame title={getTitle()}
                    refreshable={refreshBreakdown}
                    onRefresh={setRefreshDynamicPanel}
                    refreshLoading={eventProgress < 100}
        >
          <Layout>
            <Layout.Header>
              <ProgressBar eventType={eventData.type}
                           eventData={eventData.data} 
              />
            </Layout.Header>
            <Layout.Content>
              <div className="dp-current-event-data">
              {
                eventData.type.category === 'MAINTENANCE'
                ?
                <CurrentMaintenance type={eventData.type.type} data={eventData.data}/>
                :
                eventData.type.category === 'BREAKDOWN'
                ?
                <CurrentBreakdown type={eventData.type.type} 
                                  data={eventData.data}
                                  setRefreshDynamicPanel={setRefreshDynamicPanel}/>
                :
                <></>
              }
              </div>
            </Layout.Content>
            <Layout.Footer>
                {getButtons()}
            </Layout.Footer>
          </Layout>
          <AdditionalDataModal type={eventData.type} data={eventData.data} modalDisplayed={displayModal} setModalDisplayed={setDisplayModal}/>
        </PanelFrame>
      );
    } else {
        return <></>;
    }
}

export default CurrentEventPanel;
